import { SAVE_PRODUCTS_DATA } from "../actions/products";

const default_state = [];

const products = (state = default_state, action) => {
  switch (action.type) {
    case SAVE_PRODUCTS_DATA: {
      return action.payload;
    }
    default:
      return state;
  }
};

export default products;
